import {newStepValue} from "../../../../services/flowBuilder/utils/constants";

export const waitForCallback = {
    json: {
        action: {
            name: '',
            description: '',
            actionType: 'waitForCallback',
            actionParams: {
                reference: '',
            },
            result: {
                other: newStepValue,
                timeout: newStepValue,
            },
            report: ''
        },
        type: 'action',
    }
};
